import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/core/services/account.service';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';

@Component({
  selector: 'pgh-cellular-enabled-info',
  templateUrl: './cellular-enabled-info-modal.component.html',
  styleUrls: ['./cellular-enabled-info-modal.component.scss']
})
export class CellularEnabledInfoModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<CellularEnabledInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) { }

  public nickName: string;
  public deviceDetailsForm: UntypedFormGroup;
  public title: string;
  public isSaving = false;
  public selDevice: PghUserDeviceBase;
  public deviceTypeDisplayName: string = '';
  private allDevices: PghUserDeviceBase[];
  public submitButtonLabel: string;
  public cancelButtonLabel: string;
  public uniqueNicknameErrorMessage: string;

  ngOnInit() {

  }

  onCancelClicked() {
    this.dialogRef.close({ data: 'cancel' });
  }




}
